import HttpClient from "./api";

class AffiliateApi extends HttpClient {
    public constructor() {
        super();
    }

    getManagersContact() {
        return this.doGet('/api/v3/user/manager/contact');
    }

    getSettings() {
        return this.doGet('/api/v3/user/settings');
    }

    updateSettings(data: any) {
        return this.doPut('/api/v3/user/settings', data);
    }
}

export const affiliateApi = new AffiliateApi();